import script from "./MonacoIde.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonacoIde.vue?vue&type=script&setup=true&lang=ts"

import "./MonacoIde.vue?vue&type=style&index=0&id=523c348e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523c348e"]])

export default __exports__